import { React, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faSpinner } from '@fortawesome/free-solid-svg-icons'

import './DownloadButton.css'

/**
 * Einheitlicher Download-Button (z. B. Dienstplan-PDF).
 *
 * props:
 *  - title: string – Beschriftung
 *  - onDownload: fn – muss ein Promise liefern; währenddessen Spinner + deaktiviert, bei Fehler Hinweis
 *  - size: 'sm' | undefined
 */
export default function DownloadButton({ title, onDownload, size }) {
    const [loading, setLoading] = useState(false)
    const [failed, setFailed] = useState(false)

    function handleClick() {
        if (loading) return
        setFailed(false)
        setLoading(true)
        Promise.resolve()
            .then(onDownload)
            .catch(() => setFailed(true))
            .finally(() => setLoading(false))
    }

    return (
        <span className='download-btn'>
            <button
                type="button"
                className={'btn btn-secondary' + (size === 'sm' ? ' btn-sm' : '')}
                disabled={loading}
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={loading ? faSpinner : faDownload} spin={loading} />
                {' '}{title}
            </button>
            {failed ? <span className='download-btn-error'>Download fehlgeschlagen. Bitte später erneut versuchen.</span> : null}
        </span>
    )
}
